// var flkty = new Flickity('.slideshow_news_container--flickity-trigger', {
//   "wrapAround":true,
//   "dragThreshold":"15",
//   //"autoPlay": 3500,
//   "cellAlign": "center",
//   "adaptiveHeight": true,
//   "pageDots":false,
//   "prevNextButtons":false,
// });

//flkty.on( 'change', flkty.reposition );

// $(document).ready(function() {
//   setTimeout(function() {
//     var nextButton = document.querySelector('#shopify-section-footer');
//     nextButton.addEventListener( 'click', function() {
//       flkty.next();
//     });
//     $("#shopify-section-footer").click();
//   }, 0);
// });
$(document).ready(function() {
  $(".circle-text h5").lettering();
});
$(document).ready(function() {
  // Gets the span width of the filled-ratings span
  // this will be the same for each rating
  var star_rating_width = $('.fill-ratings span').width();
  // Sets the container of the ratings to span width
  // thus the percentages in mobile will never be wrong
  $('.star-ratings').width(star_rating_width);
});
/*
$(".js-modal-overlay.site-overlay").click(function(){
  $('body').css({'overflow': ''});
  console.log("clicked popup")
});

$(".product-add .js-quickview-trigger").click(function(){
  $('body').css({'overflow': 'hidden'});
  console.log("clicked btn")
});
*/
var filterGoCollection = function(takenewterm){
var patha = window.location.protocol;
var pathb = window.location.host;
window.location.href = patha+'//'+pathb+takenewterm; };
jQuery("#SortTags").change(function(){
var selectedcollection = jQuery(this).children("option:selected").val();
filterGoCollection(selectedcollection);
});
